var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-layout d-flex flex-column pa-2 pa-sm-4",
    class: {
      'fixed-height': _vm.fixedHeight
    }
  }, [_c('div', {
    staticClass: "content-wrapper d-flex",
    class: {
      'flex-column': _vm.column
    }
  }, [_vm._t("default")], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNavigation,
      expression: "showNavigation"
    }],
    staticClass: "navigation page-navigation d-flex justify-space-between align-center w-100"
  }, [_c('div', {
    staticClass: "slot"
  }, [_vm.leftButton ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('left');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.leftButton) + " ")]) : _vm._t("left")], 2), _c('div', {
    staticClass: "slot slot-right"
  }, [_vm.rightButton ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showRightDisabledHint
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "right-button-wrap"
        }, 'div', attrs, false), on), [_c('v-btn', {
          staticClass: "primary-action",
          attrs: {
            "disabled": _vm.rightDisabled || _vm.rightSpinner
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('right');
            }
          }
        }, [_vm.rightSpinner ? _c('v-progress-circular', {
          staticClass: "mr-2",
          attrs: {
            "indeterminate": "",
            "color": "grey",
            "size": "14",
            "width": "2"
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.rightButton) + " ")], 1)], 1)];
      }
    }], null, false, 302489518)
  }, [_c('span', [_vm._v(_vm._s(_vm.rightDisabledHint))])]) : _vm._t("right")], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }